import styled from "styled-components";

import { Link } from "react-router-dom";

export const CategoryPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1%;
`;

export const Title = styled(Link)`
  padding: 20px;
  font-size: 38px;
  margin-bottom: 2%;
  cursor: pointer;

  background-image: linear-gradient(to right, #54b3d6, #54b3d6 50%, #000 50%);
  background-size: 200% 100%;
  background-position: -100%;
  display: inline-block;
  padding: 5px 0;
  position: relative;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: all 0.3s ease-in-out;

  &:before {
    content: "";
    background: #54b3d6;
    display: block;
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 0;
    height: 3px;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    background-position: 0;
  }

  &:link:hover::before {
    width: 100%;
  }

  @media only screen and (max-width: 760px) {
    font-size: 27px;
    padding: 7px;
  }
`;

export const Preview = styled.div`
  background-color: #c6f0e8;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  padding: 10px;
  border-radius: 7px 7px 7px 7px;
  @media only screen and (max-width: 760px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
